import {
  ConsumptionStorageType,
  UsageGroupByType,
} from "@shared/types/localTypes/usage-explorer.ts";

export interface StorageTypeOption {
  value: ConsumptionStorageType;
  label: string;
  supported: boolean;
}

export const storageTypeOptions: StorageTypeOption[] = [
  {
    value: "binary",
    label: "Binary Size",
    supported: true,
  },
  {
    value: "artifact",
    label: "Artifact Size",
    supported: true,
  },
  {
    value: "normalized",
    label: "Normalized Size",
    supported: true,
  },
];

export const DEFAULT_STORAGE_TYPE: ConsumptionStorageType = "binary";

// group-by dimensions the backend actually returns for each storage type
export const CONSUMPTION_GROUP_BY_DIMENSIONS_BY_STORAGE_TYPE = {
  binary: [UsageGroupByType.TECHNICAL_SERVER_NAME],
  artifact: [
    UsageGroupByType.REPOSITORY,
    UsageGroupByType.PROJECT,
    UsageGroupByType.TECHNICAL_SERVER_NAME,
  ],
  normalized: [
    UsageGroupByType.REPOSITORY,
    UsageGroupByType.PROJECT,
    UsageGroupByType.TECHNICAL_SERVER_NAME,
  ],
} as const satisfies Record<
  ConsumptionStorageType,
  ReadonlyArray<UsageGroupByType>
>;
